import { type Ref, ref } from 'vue';

import { IS_DEV_STAGE } from '@/js/constants';
import { hrefTargetEnum } from '@/js/hrefTarget';
import type { GlobalConfig } from '@/types/global';

// NOTE: 僅限在測試環境，提供可測試 PIP 模式
const debugModeAppendConfigFromUrlSearch = (): void => {
  const urlObject = new URL(location.href);

  if (urlObject.searchParams.has('piponly')) {
    window.HANDSUP_CMS = window.HANDSUP_CMS || {};
    window.HANDSUP_CMS.init = window.HANDSUP_CMS.init || {};
    window.HANDSUP_CMS.init.PIP_ONLY = true;
  }
};

if (IS_DEV_STAGE) { 
  debugModeAppendConfigFromUrlSearch(); 
}

const initGlobalConfig = (): Ref<GlobalConfig> => {
  const userConfig = window?.HANDSUP_CMS?.init ?? {};

  // 只考慮 CMS SDK 只有一個 component 包含 stream，多個 stream component 同時出現可能會造成 issue
  const [randomValue] = window.crypto.getRandomValues(new Uint32Array(1));
  const localStreamId = `HANDSUP_STREAM_${randomValue}`;

  return ref<GlobalConfig>({
    // if PIP_ONLY is true, ignore STREAM_ROOM_MOUNT_POINT_ID & CMS_MOUNT_POINT_ID
    isPipOnly: userConfig?.PIP_ONLY ?? false,

    // priority: STREAM_ROOM_MOUNT_POINT_ID > CMS_MOUNT_POINT_ID
    // if STREAM_ROOM_MOUNT_POINT_ID set, ignore CMS layout_content
    streamRoomMountPointId: userConfig?.STREAM_ROOM_MOUNT_POINT_ID ?? null,

    cmsMountPointId: userConfig?.CMS_MOUNT_POINT_ID ?? 'app',

    openWindowType: hrefTargetEnum[userConfig?.OPEN_WINDOW_TYPE as keyof typeof hrefTargetEnum] ?? null,

    liveSellingPageUrl: userConfig?.RETURN_LIVE_SELLING_PAGE_URL ?? null,

    localStreamId,
  });
};

export const globalConfig = initGlobalConfig();
